<!-- eslint-disable max-len -->
<route>
{
  "meta": {
    "requireAdmin": true,
    "customSite": true
  }
}
</route>
<template>
  <div class="py-1">
    <div class="absolute top-right">
      <button
        @click="$router.push('/admin/products/new')"
        type="button"
        class="btn btn-primary"
      >
        <font-awesome-icon class="mr-3" size="lg" :icon="['fas', 'plus']" />
        Add New
      </button>
    </div>
    <div class="pl-3 mb-8" v-for="course in courses" :key="course._id">
      <div class="flex-nowrap w-full flex justify-between items-center ">
        <div class="mt-5 mr-8">
          <h3 class="font-medium text-xl inline-block">{{ course.title }}</h3>
        </div>
        <div class="text-right flex flex-nowrap mr-6 mt-2">
          <div class="tooltip" data-tip="Create new Lesson">
            <font-awesome-icon
              class="reaction text-gray-600"
              size="lg"
              :icon="['fas', 'plus']"
              @click="$router.push(`/admin/lessons/new/${course._id}`)"
            />
          </div>
          <div class="tooltip" data-tip="Edit Course">
            <font-awesome-icon
              class="reaction text-gray-600 ml-4"
              size="lg"
              :icon="['far', 'edit']"
              @click="$router.push(`/admin/products/${course._id}`)"
            />
          </div>
          <div class="tooltip" data-tip="Delete Course">
            <font-awesome-icon
              class="reaction text-gray-600 ml-4"
              size="lg"
              :icon="['far', 'trash-alt']"
              @click="setModalDetails('course', course._id)"
            />
          </div>
          <div class="tooltip" data-tip="Students list">
            <font-awesome-icon
              class="reaction text-gray-600 ml-4"
              size="lg"
              :icon="['fas', 'users']"
              @click="$router.push(`/admin/enrolled-student/${course._id}`)"
            />
          </div>
          <div
            v-if="course.type === 'twitter'"
            class="tooltip"
            data-tip="Announce Course"
          >
            <font-awesome-icon
              class="reaction text-gray-600 ml-4"
              size="lg"
              :icon="['fas', 'bullhorn']"
              @click="setpromoDetails(course)"
            />
          </div>
          <div
            v-if="course.type === 'twitter'"
            class="tooltip"
            data-tip="Course Notifications"
          >
            <font-awesome-icon
              class="reaction text-gray-600 ml-4"
              size="lg"
              :icon="['fas', 'stopwatch']"
              @click="setNotifications(course)"
            />
          </div>
          <div class="tooltip" data-tip="Clone Course">
            <font-awesome-icon
              class="reaction text-gray-600 ml-4"
              size="lg"
              :icon="['fas', 'clone']"
              @click="clonecourse(course._id)"
            />
          </div>
        </div>
      </div>
      <div
        class="flex-nowrap w-full flex justify-between items-center bg-white p-6 mb-1"
        v-for="(lesson, index) in course.lessons"
        :key="lesson._id"
      >
        <div class="flex">
          <span>
            {{ index + 1 }}
          </span>
          <h3 class="font-medium text-base inline-block mb-0 ml-5 mr-8">
             {{ lesson.title }}
          </h3>
        </div>
        <div class="text-right flex flex-nowrap">
          <div class="tooltip" data-tip="Lesson Thread">
            <font-awesome-icon
              v-if="lesson.tweetUrl"
              class="reaction text-gray-600"
              size="lg"
              :icon="['fas', 'link']"
              @click="OpenLessonthread(lesson.tweetUrl)"
            />
          </div>
          <div class="tooltip" data-tip="Edit Lesson">
            <font-awesome-icon
              class="reaction text-gray-600 ml-4"
              size="lg"
              :icon="['far', 'edit']"
              @click="
                $router.push(`/admin/lessons/${course._id}/${lesson._id}`)
              "
            />
          </div>
          <div class="tooltip" data-tip="Delete Lesson">
            <font-awesome-icon
              class="reaction text-gray-600 ml-4"
              size="lg"
              :icon="['far', 'trash-alt']"
              @click="setModalDetails('lesson', lesson._id)"
            />
          </div>
          <div class="tooltip" data-tip="Move Up">
            <font-awesome-icon
              class="reaction text-gray-600 ml-4"
              size="lg"
              :icon="['fas', 'arrow-up']"
              @click="changeorder(lesson, course.lessons[index - 1])"
            />
          </div>
          <div class="tooltip" data-tip="Move Down">
            <font-awesome-icon
              class="reaction text-gray-600 ml-4"
              size="lg"
              :icon="['fas', 'arrow-down']"
              @click="changeorder(course.lessons[index + 1], lesson)"
            />
          </div>
          <div class="tooltip" data-tip="Clone Lesson">
            <font-awesome-icon
              class="reaction text-gray-600 ml-4"
              size="lg"
              :icon="['fas', 'clone']"
              @click="clonelesson(lesson._id, course._id)"
            />
          </div>
        </div>
      </div>
    </div>
    <div>
      <ul
        role="list"
        class="space-y-12 sm:space-y-0 sm:-mt-8 lg:mt-3 lg:gap-x-8 lg:space-y-8"
        v-if="false && courses.length > 0"
      >
        <li
          v-for="item in courses"
          :key="item._id"
          class="sm:py-8 shadow rounded mb-5"
        >
          <div
            class="
              space-y-4
              sm:grid
              lg:flex
              sm:items-start sm:gap-6 sm:space-y-0
            "
          >
            <div class="mx-5">
              <img
                class="w-48 inline-block object-contain p-3 self-center"
                :src="item.image"
                :alt="item._id"
              />
            </div>
            <div class="w-full px-5">
              <div class="space-y-1 w-full">
                <div
                  class="
                    flex
                    justify-between
                    text-xl
                    font-bold
                    leading-6
                    space-y-1
                  "
                >
                  <h3 class="mb-0">{{ item.title }}</h3>
                  <h3 class="mb-0">
                    {{
                      item.price == 0
                        ? 'Free'
                        : item.currency == 'USD'
                        ? `$${item.price}`
                        : item.price
                    }}
                  </h3>
                </div>
                <div class="text-lg">
                  <p class="text-gray-900 mb-1">
                    {{ item.description }}
                  </p>
                  <!-- <p class="text-gray-800">ESTD: {{ item.estdTime }}</p> -->
                </div>
                <div class="border-t pt-2 flex justify-end space-x-5">
                  <router-link
                    :to="`/admin/products/${item._id}`"
                    type="button"
                    class="
                      inline-flex
                      items-center
                      px-4
                      py-2
                      border-2 border-transparent
                      text-base
                      font-medium
                      rounded-md
                      shadow-sm
                      text-white
                      bg-primaryColor
                      hover:bg-secondaryColor
                      focus:outline-none
                      focus:ring-2
                      focus:ring-offset-2
                      focus:ring-indigo-500
                      hover:no-underline
                    "
                  >
                    Edit
                  </router-link>
                  <router-link
                    :to="`/admin/lessons/view/${item._id}`"
                    type="button"
                    class="
                      bg-transparent
                      hover:bg-blue
                      text-blue-dark
                      font-semibold
                      border-2
                      py-2
                      px-4
                      border border-blue
                      rounded
                      hover:no-underline
                    "
                  >
                    View Lessons
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div class="rounded-md bg-blue-50 p-4">
        <div v-if="courses.length <= 0" class="flex">
          <div class="flex-shrink-0">
            <!-- Heroicon name: solid/information-circle -->
            <svg
              class="h-5 w-5 text-blue-400"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
          <div class="ml-3 flex-1 md:flex md:justify-between">
            <p class="text-sm text-blue-700">
              There's no courses created by the creator right now.
            </p>
          </div>
        </div>
      </div>
    </div>
    <transition
      enter-active-class="transition duration-300 ease-out transform"
      enter-class="scale-95 opacity-0"
      enter-to-class="scale-100 opacity-100"
      leave-active-class="transition duration-150 ease-in transform"
      leave-class="scale-100 opacity-100"
      leave-to-class="scale-95 opacity-0"
    >
      <div
        v-if="feedPopup"
        class="
          flex
          items-center
          justify-center
          fixed
          left-0
          bottom-0
          w-full
          h-full
        "
        style="background-color: #00000099"
      >
        <div class="bg-white rounded-lg w-1/4">
          <div class="flex flex-col items-start p-4">
            <div class="flex items-center w-full">
              <div class="text-gray-900 font-bold text-lg">
                Delete Confirmation
              </div>
              <svg
                class="
                  ml-auto
                  fill-current
                  text-gray-700
                  w-6
                  h-6
                  cursor-pointer
                "
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 18 18"
                @click="closePopup"
              >
                <path
                  d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
                />
              </svg>
            </div>
            <hr class="w-full my-3" />
            <div class="">Are you sure you want to delete this?</div>
            <hr class="w-full my-3" />
            <div class="ml-auto">
              <button class="btn btn-primary" @click="deleteConfirmed">
                Yes
              </button>
              <button class="btn btn-outline ml-3" @click="closePopup">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition
      enter-active-class="transition duration-300 ease-out transform"
      enter-class="scale-95 opacity-0"
      enter-to-class="scale-100 opacity-100"
      leave-active-class="transition duration-150 ease-in transform"
      leave-class="scale-100 opacity-100"
      leave-to-class="scale-95 opacity-0"
    >
      <div
        v-if="promoPopup"
        class="
          flex
          items-center
          justify-center
          fixed
          left-0
          bottom-0
          w-full
          h-full
        "
        style="background-color: #00000099"
      >
        <div class="bg-white rounded-lg w-1/2 max-h-95/100">
          <div class="flex flex-col items-start p-4">
            <div class="flex items-center w-full">
              <div class="text-gray-900 font-bold text-lg">Announce Course</div>
              <svg
                class="
                  ml-auto
                  fill-current
                  text-gray-700
                  w-6
                  h-6
                  cursor-pointer
                "
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 18 18"
                @click="
                  promoPopup = false;
                  content = '';
                  Type = '';
                "
              >
                <path
                  d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
                />
              </svg>
            </div>
            <hr class="w-full my-3" />
            <div class="form-control w-full">
              <div class="text-xl w-full inline-block">
                Tweet Url's to announce for this course
              </div>
              <span v-if="!Announce.length" class="text-md"
                >There are no Tweet Url for this course yet.</span
              >
              <div class="max-h-96 overflow-y-auto">
                <div
                  class="flex flex-row mt-3 mb-2 w-full"
                  v-for="(Tweeturl, index) in Announce"
                  :key="Tweeturl"
                >
                  <span class="text-md"> {{ index + 1 }}) </span>
                  <a
                    class="ml-1 cursor-pointer"
                    target="_blank"
                    :href="Tweeturl"
                    >{{ Tweeturl.substring(0, 95)
                    }}{{ Tweeturl.length > 95 ? '..' : '' }}</a
                  >
                  <div class="text-right ml-auto mr-3">
                    <font-awesome-icon
                      class="reaction text-gray-600 ml-4"
                      size="lg"
                      :icon="['far', 'trash-alt']"
                      @click="
                        setModalDetails('Tweet', Tweeturl);
                        promoPopup = false;
                      "
                    />
                  </div>
                </div>
              </div>
              <div class="text-xl mt-1 inline-block">Announce Type:</div>
              <div class="mr-auto mt-3">
                <button
                  :class="
                    Type === 'NewTweet' ? 'btn btn-primary' : 'btn btn-outline'
                  "
                  @click="
                    Type = 'NewTweet';
                    content = '';
                  "
                >
                  Send a New Tweet
                </button>
                <button
                  :class="
                    Type === 'TweetId'
                      ? 'btn btn-primary ml-3'
                      : 'btn btn-outline ml-3'
                  "
                  @click="
                    Type = 'TweetId';
                    content = '';
                  "
                >
                  Add Tweet URL
                </button>
              </div>
              <!--
            <label class="cursor-pointer label justify-start" style="width: fit-content">
              <input
                type="radio"
                value="NewTweet"
                v-model="Type"
                class="h-4 w-4 text-primaryColor border-indigo-900 border-2"
              />
              <span class="label-text text-lg ml-3">Send a New Tweet</span>
            </label>

            <label class="cursor-pointer label justify-start" style="width: fit-content">
              <input
                type="radio"
                value="TweetId"
                v-model="Type"
                class="h-4 w-4 text-primaryColor border-indigo-900 border-2"
              />
              <span class="label-text text-lg ml-3">Add Tweet URL</span>
            </label>
            -->
              <input
                v-if="Type === 'TweetId'"
                type="text"
                placeholder="Tweet Url"
                class="input mt-3 input-bordered w-full mb-2"
                required
                name="content"
                :input="(content = content.trim())"
                v-model="content"
              />
              <textarea
                v-if="Type === 'NewTweet'"
                class="textarea h-32 mt-3 textarea-bordered w-full mb-1"
                placeholder="Message"
                required
                name="content"
                v-model="content"
              />
              <span v-if="content.length > 280" class="text-md"
                >The maxLimit is exceeds.</span
              >
            </div>
            <hr class="w-full my-3" />
            <div class="ml-auto">
              <button
                :disabled="
                  content.length > 280 ||
                  (Type === 'TweetId'
                    ? content.indexOf('https://twitter.com/') === -1
                    : content.trim() === '')
                "
                class="btn btn-primary"
                @click="addPromo"
              >
                {{ Type === 'NewTweet' ? 'Send' : 'Add' }}
              </button>
              <button
                class="btn btn-outline ml-3"
                @click="
                  promoPopup = false;
                  content = '';
                  Type = '';
                "
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition
      enter-active-class="transition duration-300 ease-out transform"
      enter-class="scale-95 opacity-0"
      enter-to-class="scale-100 opacity-100"
      leave-active-class="transition duration-150 ease-in transform"
      leave-class="scale-100 opacity-100"
      leave-to-class="scale-95 opacity-0"
    >
      <div
        v-if="notificationPopup"
        class="
          flex
          items-center
          justify-center
          fixed
          left-0
          bottom-0
          w-full
          h-full
        "
        style="background-color: #00000099"
      >
        <div class="bg-white rounded-lg w-1/2 max-h-90/100">
          <div class="flex flex-col items-start p-4">
            <div class="flex items-center w-full">
              <div class="text-gray-900 font-bold text-xl">
                Course Notifications
              </div>
              <svg
                class="
                  ml-auto
                  fill-current
                  text-gray-700
                  w-6
                  h-6
                  cursor-pointer
                "
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 18 18"
                @click="notificationPopup = false"
              >
                <path
                  d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
                />
              </svg>
            </div>
            <hr class="w-full my-3" />
            <div class="form-control w-full max-h-75 overflow-y-auto">
              <div v-if="notificationData.type === 'twitter'">
                  <div class="flex items-center justify-between">
                    <div class="text-lg font-bold mt-1 inline-block">
                      {{ defaultMessages.signupCourseMessage.title }}
                    </div>
                    <div>
                      <button
                        class="btn btn-outline mt-3 mb-2"
                        @click="
                          signupCourseMessage =
                            defaultMessages.signupCourseMessage.message
                        "
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                  <textarea
                    class="textarea h-20 mt-3 textarea-bordered w-full mb-1"
                    placeholder="Message"
                    required
                    name="signupCourseMessage"
                    v-model="signupCourseMessage"
                  />
                <div v-if="notificationData.medium === 'SITE' || notificationData.medium === 'SITE-NOTE'">
                  <div class="flex items-center justify-between">
                    <div class="text-lg font-bold mt-1 inline-block">
                      {{ defaultMessages.lessonAvailable.title }}
                    </div>
                    <div>
                      <button
                        class="btn btn-outline mt-3 mb-2"
                        @click="
                          lessonAvailableMessageSITE =
                            defaultMessages.lessonAvailable.message
                        "
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                  <textarea
                    class="textarea h-20 mt-3 textarea-bordered w-full mb-1"
                    placeholder="Message"
                    required
                    name="lessonAvailableMessageSITE"
                    v-model="lessonAvailableMessageSITE"
                  />
                </div>
                <div v-if="notificationData.medium === 'TWEET'">
                  <div class="flex items-center justify-between">
                    <div class="text-lg font-bold mt-1 inline-block">
                      {{ defaultMessages.lessonAvailable.title }}
                    </div>
                    <div>
                      <button
                        class="btn btn-outline mt-3 mb-2"
                        @click="
                          lessonAvailableMessageTWEET =
                            defaultMessages.lessonAvailable.message
                        "
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                  <textarea
                    class="textarea h-20 mt-3 textarea-bordered w-full mb-1"
                    placeholder="Message"
                    required
                    name="lessonAvailableMessageTWEET"
                    v-model="lessonAvailableMessageTWEET"
                  />
                </div>
                <div v-if="notificationData.showFeedback">
                  <div class="flex items-center justify-between">
                    <div class="text-lg mt-1 font-bold inline-block">
                      {{ defaultMessages.feedbackAvailable.title }}
                    </div>
                    <div>
                      <button
                        class="btn btn-outline mt-3 mb-2"
                        @click="
                          feedbackAvailableMessage =
                            defaultMessages.feedbackAvailable.message
                        "
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                  <textarea
                    class="textarea h-20 mt-3 textarea-bordered w-full mb-1"
                    placeholder="Message"
                    required
                    name="feedbackAvailableMessage"
                    v-model="feedbackAvailableMessage"
                  />
                </div>
                <div v-if="notificationData.showParticipate">
                  <div class="flex items-center justify-between">
                    <div class="text-lg mt-1 font-bold inline-block">
                      {{ defaultMessages.participationAvailable.title }}
                    </div>
                    <div>
                      <button
                        class="btn btn-outline mt-3 mb-2"
                        @click="
                          participationAvailableMessage =
                            defaultMessages.participationAvailable.message
                        "
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                  <textarea
                    class="textarea h-20 mt-3 textarea-bordered w-full mb-1"
                    placeholder="Message"
                    required
                    name="participationAvailableMessage"
                    v-model="participationAvailableMessage"
                  />
                </div>
                <div
                  v-if="
                    notificationData.medium === 'TWEET' ||
                    notificationData.medium === 'DM'
                  "
                >
                  <div class="flex items-center justify-between">
                    <div class="text-lg mt-1 font-bold inline-block">
                      {{ defaultMessages.tipsAvailable.title }}
                    </div>
                    <div>
                      <button
                        class="btn btn-outline mt-3 mb-2"
                        @click="
                          tipsAvailableMessage =
                            defaultMessages.tipsAvailable.message
                        "
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                  <textarea
                    class="textarea h-20 mt-3 textarea-bordered w-full mb-1"
                    placeholder="Message"
                    required
                    name="tipsAvailableMessage"
                    v-model="tipsAvailableMessage"
                  />
                </div>
              </div>
            </div>
            <hr class="w-full my-3" />
            <div class="ml-auto">
              <button
                :disabled="
                  signupCourseMessage.trim() === '' ||
                  (notificationData.medium === 'SITE' || notificationData.medium === 'SITE-NOTE' &&
                    (lessonAvailableMessageSITE.trim() === '' ||
                      feedbackAvailableMessage.trim() === '' ||
                      participationAvailableMessage.trim() === '')) ||
                  (notificationData.medium === 'DM' &&
                    (feedbackAvailableMessage.trim() === '' ||
                      participationAvailableMessage.trim() === '' ||
                      tipsAvailableMessage.trim() === '')) ||
                  (notificationData.medium === 'TWEET' &&
                    (lessonAvailableMessageTWEET.trim() === '' ||
                      feedbackAvailableMessage.trim() === '' ||
                      participationAvailableMessage.trim() === '' ||
                      tipsAvailableMessage.trim() === ''))
                "
                class="btn btn-primary"
                @click="updateNotification"
              >
                Update
              </button>
              <button
                class="btn btn-outline ml-3"
                @click="notificationPopup = false"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import courseAPI from '@/services/course';
import lessonAPI from '@/services/lesson';
import userInfo from '@/services/userInfo';
import store from '@/store';
import utils from '@/services/utils';

export default {
  name: 'course',
  layout: 'admin',
  store,
  data() {
    return {
      userInfo: null,
      courses: [],
      open: false,
      feedPopup: false,
      whatToDelete: '',
      deleteId: null,
      content: '',
      promoPopup: false,
      notificationData: {},
      notificationPopup: false,
      coursedata: [],
      Announce: [],
      Type: '',
      defaultMessages: {},
      lessonAvailableMessage: '',
      lessonAvailableMessageSITE: '',
      lessonAvailableMessageTWEET: '',
      feedbackAvailableMessage: '',
      participationAvailableMessage: '',
      tipsAvailableMessage: '',
      signupCourseMessage: '',
    };
  },
  computed: {
    user() {
      return store.state.user;
    },
  },
  async mounted() {
    store.commit('toggleLoading', true);
    this.userInfo = await userInfo.getUserInfo(this.user.uid);
    this.fetchCourse();
  },
  methods: {
    closePopup() {
      this.feedPopup = false;
      this.promoPopup = this.whatToDelete === 'Tweet';
    },
    clonecourse(cid) {
      store.commit('toggleLoading', true);
      const payload = {
        courseId: cid,
      };
      console.log(payload);
      courseAPI
        .cloneCourse(payload)
        .then(() => {
          this.fetchCourse();
        })
        .catch((error) => {
          store.commit('toggleLoading', false);
          if (error.response.status === 401) {
            utils.setStatusMsg(
              this,
              'Unauthorized access, redirected to implicit',
            );
            this.$router.push({ path: '/' });
          }
          console.log({ error });
        });
    },
    clonelesson(id, cid) {
      store.commit('toggleLoading', true);
      const payload = {
        courseId: cid,
        lessonId: id,
      };
      console.log(payload);
      lessonAPI
        .cloneLesson(payload)
        .then(() => {
          this.fetchCourse();
        })
        .catch((error) => {
          store.commit('toggleLoading', false);
          if (error.response.status === 401) {
            utils.setStatusMsg(
              this,
              'Unauthorized access, redirected to implicit',
            );
            this.$router.push({ path: '/' });
          }
          console.log({ error });
        });
    },
    changeorder(lesson, lesson2) {
      if (!lesson) {
        utils.setStatusMsg(this, 'Lesson is already on last');
      } else if (!lesson2) {
        utils.setStatusMsg(this, 'Lesson is already on first');
      } else {
        store.commit('toggleLoading', true);
        const lessonsdata = [];
        lessonsdata.push({
          lessonId: lesson._id,
          display_priority: lesson2.display_priority,
        });
        lessonsdata.push({
          lessonId: lesson2._id,
          display_priority: lesson.display_priority,
        });
        lessonAPI
          .changedisplayPriority({ lessons: lessonsdata })
          .then(() => {
            this.fetchCourse();
          })
          .catch((error) => {
            store.commit('toggleLoading', false);
            if (error.response.status === 401) {
              utils.setStatusMsg(
                this,
                'Unauthorized access, redirected to implicit',
              );
              this.$router.push({ path: '/' });
            }
            console.log({ error });
          });
      }
    },
    OpenLessonthread(url) {
      console.log(url);
      window.location.href = url;
    },
    setModalDetails(whatToDelete, deleteId) {
      this.whatToDelete = whatToDelete;
      this.deleteId = deleteId;
      this.feedPopup = true;
    },
    async setpromoDetails(course) {
      store.commit('toggleLoading', true);
      this.coursedata = course;
      const data = await courseAPI.getPromo(course._id);
      this.Announce = data.data;
      this.promoPopup = true;
      store.commit('toggleLoading', false);
    },
    async setNotifications(course) {
      store.commit('toggleLoading', true);
      const data = await courseAPI.getNotifications(course._id);
      this.notificationData = data.data.course;
      this.defaultMessages = data.data.defaultMessages;
      this.notificationPopup = true;

      async function feedBackAndParticipation() {
        if (this.notificationData.signupCourseMessage !== '') {
          this.signupCourseMessage =
            this.notificationData.signupCourseMessage;
        } else {
          this.signupCourseMessage =
            this.defaultMessages.signupCourseMessage.message;
        }

        if (this.notificationData.feedbackAvailableMessage !== '') {
          this.feedbackAvailableMessage =
            this.notificationData.feedbackAvailableMessage;
        } else {
          this.feedbackAvailableMessage =
            this.defaultMessages.feedbackAvailable.message;
        }

        if (this.notificationData.participationAvailableMessage !== '') {
          this.participationAvailableMessage =
            this.notificationData.participationAvailableMessage;
        } else {
          this.participationAvailableMessage =
            this.defaultMessages.participationAvailable.message;
        }
      }

      if (this.notificationData.medium === 'SITE') {
        if (this.notificationData.lessonAvailableMessage !== '') {
          this.lessonAvailableMessageSITE =
            this.notificationData.lessonAvailableMessage;
        } else {
          this.lessonAvailableMessageSITE =
            this.defaultMessages.lessonAvailable.message;
        }

        feedBackAndParticipation.call(this);
      } else if (this.notificationData.medium === 'SITE-NOTE') {
        if (this.notificationData.lessonAvailableMessage !== '') {
          this.lessonAvailableMessageSITE =
            this.notificationData.lessonAvailableMessage;
        } else {
          this.lessonAvailableMessageSITE =
            this.defaultMessages.lessonAvailable.message;
        }

        feedBackAndParticipation.call(this);
      } else if (this.notificationData.medium === 'TWEET') {
        if (this.notificationData.lessonAvailableMessage !== '') {
          this.lessonAvailableMessageTWEET =
            this.notificationData.lessonAvailableMessage;
        } else {
          this.lessonAvailableMessageTWEET =
            this.defaultMessages.lessonAvailable.message;
        }

        feedBackAndParticipation.call(this);

        if (this.notificationData.tipsAvailableMessage !== '') {
          this.tipsAvailableMessage =
            this.notificationData.tipsAvailableMessage;
        } else {
          this.tipsAvailableMessage =
            this.defaultMessages.tipsAvailable.message;
        }
      } else if (this.notificationData.medium === 'DM') {
        feedBackAndParticipation.call(this);

        if (this.notificationData.tipsAvailableMessage !== '') {
          this.tipsAvailableMessage =
            this.notificationData.tipsAvailableMessage;
        } else {
          this.tipsAvailableMessage =
            this.defaultMessages.tipsAvailable.message;
        }
      }

      store.commit('toggleLoading', false);
    },
    fetchCourse() {
      store.commit('toggleLoading', true);
      courseAPI
        .getCourses(this.userInfo.user.userId)
        .then((data) => {
          store.commit('toggleLoading', false);
          this.courses = data.courses;
        })
        .catch((error) => {
          store.commit('toggleLoading', false);
          if (error.response.status === 401) {
            utils.setStatusMsg(
              this,
              'Unauthorized access, redirected to implicit',
            );
            this.$router.push({ path: '/' });
          }
          console.log({ error });
        });
    },
    addPromo() {
      store.commit('toggleLoading', true);
      console.log(this.Type);
      console.log(this.content);
      const payload = {
        type: this.Type,
        tweetUrl: this.content,
        courseId: this.coursedata._id,
        message: this.content,
      };
      courseAPI
        .addPromo(payload)
        .then((data) => {
          store.commit('toggleLoading', false);
          utils.setStatusMsg(this, 'Tweet Url Successfully Added');
          this.promoPopup = false;
          this.content = '';
          this.Type = 'NewTweet';
          this.fetchCourse();
          console.log(data);
        })
        .catch((error) => {
          store.commit('toggleLoading', false);
          this.promoPopup = false;
          this.content = '';
          this.Type = '';
          if (error.response.status === 401) {
            utils.setStatusMsg(
              this,
              'Unauthorized access, redirected to implicit',
            );
            this.$router.push({ path: '/' });
          }
          if (error.response.status === 400) {
            utils.setStatusMsg(
              this,
              `Tweet Url ${error.response.data.message}`,
            );
          }
          console.log({ error });
        });
      const tweetId = this.content.split('/')[5];
      console.log(tweetId);
      console.log(this.coursedata._id);
    },
    updateNotification() {
      store.commit('toggleLoading', true);
      if (this.notificationData.medium === 'SITE' || this.notificationData.medium === 'SITE-NOTE') {
        this.lessonAvailableMessage = this.lessonAvailableMessageSITE;
      } else if (this.notificationData.medium === 'TWEET') {
        this.lessonAvailableMessage = this.lessonAvailableMessageTWEET;
      }
      const payload = {
        courseId: this.notificationData._id,
        signupCourseMessage: this.signupCourseMessage,
        lessonAvailableMessage: this.lessonAvailableMessage,
        feedbackAvailableMessage: this.feedbackAvailableMessage,
        participationAvailableMessage: this.participationAvailableMessage,
        tipsAvailableMessage: this.tipsAvailableMessage,
      };
      courseAPI
        .updateNotification(payload)
        .then((data) => {
          store.commit('toggleLoading', false);
          utils.setStatusMsg(this, 'Notification Successfully Updated');
          this.notificationPopup = false;
          this.fetchCourse();
          console.log(data);
        })
        .catch((error) => {
          store.commit('toggleLoading', false);
          this.notificationPopup = false;
          if (error.response.status === 401) {
            utils.setStatusMsg(
              this,
              'Unauthorized access, redirected to implicit',
            );
            this.$router.push({ path: '/' });
          }
          console.log({ error });
        });
    },
    deleteConfirmed() {
      store.commit('toggleLoading', true);
      if (this.whatToDelete === 'course') {
        courseAPI
          .deleteCourse(this.deleteId)
          .then(() => {
            this.closePopup();
            this.fetchCourse();
          })
          .catch((error) => {
            this.closePopup();
            store.commit('toggleLoading', false);
            if (error.response.status === 401) {
              utils.setStatusMsg(
                this,
                'Unauthorized access, redirected to implicit',
              );
              this.$router.push({ path: '/' });
            }
            if (error.response.status === 400) {
              utils.setStatusMsg(this, error.response.data.message);
            }
            console.log({ error });
          });
      } else if (this.whatToDelete === 'Tweet') {
        console.log('delete tweetId >> ', this.deleteId);
        const payload = {
          tweetUrl: this.deleteId,
          courseId: this.coursedata._id,
        };
        courseAPI
          .deletePromo(payload)
          .then(async () => {
            utils.setStatusMsg(this, 'Announce Tweet Url Successfully Deleted');
            this.setpromoDetails(this.coursedata);
            this.closePopup();
          })
          .catch((error) => {
            store.commit('toggleLoading', false);
            if (error.response.status === 401) {
              utils.setStatusMsg(
                this,
                'Unauthorized access, redirected to implicit',
              );
              this.$router.push({ path: '/' });
            }
            console.log({ error });
          });
      } else {
        lessonAPI
          .deleteLesson(this.deleteId)
          .then(() => {
            this.closePopup();
            this.fetchCourse();
          })
          .catch((error) => {
            store.commit('toggleLoading', false);
            if (error.response.status === 401) {
              utils.setStatusMsg(
                this,
                'Unauthorized access, redirected to implicit',
              );
              this.$router.push({ path: '/' });
            }
            console.log({ error });
          });
      }
    },
  },
};
</script>

<style>
.top-right {
  top: 1.5rem;
  right: 4rem;
}
.reaction:hover {
  @apply cursor-pointer;
}
</style>
